import { useEffect } from "react";
import { fetchData, trackBtnClick } from "@/lib/helper";

export default function RedirectPage() {
  useEffect(() => {
    const performRedirect = async () => {
      const appUrl = "https://circlepe.club/download-app";
      const homeUrl = "https://circlepe.club/home";

      try {
        const userData = await fetchData("user/me");
        console.log("Fetched user data:", userData);

        const hasFirstName = !!userData?.first_name;

        if (hasFirstName) {
          trackBtnClick("Redirect", "Post-OTP", "Existing User - Completed Profile");
          window.location.replace(homeUrl);
        } else {
          trackBtnClick("Redirect", "Post-OTP", "User Missing First Name");
          window.location.replace(appUrl);
        }
      } catch (err) {
        console.error("Redirect failed:", err);
        // Fallback to home
        window.location.replace(homeUrl);
      }
    };

    performRedirect();
  }, []);

  return (
    <div className="w-full h-screen flex items-center justify-center text-center">
      <p className="text-sm text-gray-500">Redirecting you to the right place...</p>
    </div>
  );
}
